import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../Layout';
import NonAuthLayout from '../Layout/NonAuthLayout';

//routes
import { authProtectedRoutes } from "./allRoutes";
import { publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import { useSelector } from 'react-redux';

const Index = () => {

    const state = useSelector(state => state?.Auth);


    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            key={idx}
                            path={route.path}
                            element={<NonAuthLayout> {route.component} </NonAuthLayout>}
                        // exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            key={idx}
                            path={route.path}
                            element={<AuthProtected> <Layout>{route.component}</Layout> </AuthProtected>}
                        // exact={true}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
}

export default Index;
